<template>
  <Tooltip :text="tooltext" :hide-delay="200">
    <button
      type="button"
      :class="buttonClass"
      @click="fullscreen = !fullscreen"
    >
      <i
        class="bi"
        :class="{ 'bi-fullscreen': !fullscreen, 'bi-fullscreen-exit': fullscreen }"
      />
    </button>
  </Tooltip>
</template>
<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'
import { useI18n } from 'vue-i18n'
import { useUiStore } from '@/stores/ui'
import Tooltip from '@/components/tooltip.vue'

const { t } = useI18n()

const props = defineProps({
  class: {
    type: String,
    default: 'btn btn-secondary btn-sm',
  },
})

const buttonClass = computed(() => props.class)

const { fullscreen } = storeToRefs(useUiStore())
const tooltext = computed(() =>
  fullscreen.value ? t('exitFullscreen') : t('enterFullscreen')
)
</script>

<i18n>
{
  "ru": {
    "enterFullscreen": "Полный экран",
    "exitFullscreen": "Покинуть полноэкранный режим"
  },
  "en": {
    "enterFullscreen": "Enter full screen",
    "exitFullscreen": "Exit full screen"
  }
}
</i18n>

<style scoped>
.fullscreen-btn-trigger {
  min-width: 2.25rem;
  min-height: 2.25rem;
  align-items: center;
  justify-content: center;
}
</style>
